<div class="numeric-keypad grid-container">
  <div
    class="row horizontal-ac grid-container-row"
    [class.is-last-row]="i === keys.length - 1"
    *ngFor="let row of keys; let i = index; trackBy: trackByIndex"
  >
    <button
      *ngFor="let key of row; let j = index; trackBy: trackByIndex"
      class="key focusable-element"
      [style]="'fontSize.28'| translate"
      [class.is-last-key]="j === row.length - 1"
      [class.backspace]="key === 'BACK'"
      [class.double-width]="key === '0'"
      (click)="onKeyClick(key)"
      (keydown)="onKeyDown($event, i, j)"
    >
      <ng-container *ngIf="key !== 'BACK'; else backspaceIcon">{{
        key
      }}</ng-container>
      <ng-template #backspaceIcon>
        <app-icon [icon]="'back-space'"></app-icon>
      </ng-template>
    </button>
  </div>
</div>
